<template>
    <div class="projekt topspacing-big">
        <div class="header-big">
            <div class="left" @click="goBack()">
               <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px" viewBox="0 0 240.823 240.823" style="enable-background:new 0 0 240.823 240.823;" xml:space="preserve" width="18px" height="18px">
                    <g>
                        <path id="Chevron_Right" d="M57.633,129.007L165.93,237.268c4.752,4.74,12.451,4.74,17.215,0c4.752-4.74,4.752-12.439,0-17.179   l-99.707-99.671l99.695-99.671c4.752-4.74,4.752-12.439,0-17.191c-4.752-4.74-12.463-4.74-17.215,0L57.621,111.816   C52.942,116.507,52.942,124.327,57.633,129.007z" fill="#FFFFFF"/>
                    </g>
                </svg>
            </div>
            <h1>{{filteredResult.bookingTypeNavn}}</h1>
            <div class="right">
                <i class="material-icons" style="visibility: hidden">receipt</i>
            </div>
            <!-- <div class="right" data-toggle="bottommenu" aria-controls="bottommenu" @click="receipt">
                <i class="material-icons">receipt</i>
            </div> -->
            <div class="info-user">
                <p v-if="filteredResult && !filteredResult.adresse.etage && !filteredResult.adresse.doer" class="small-text">{{filteredResult.adresse.vejnavn + ' ' +  filteredResult.adresse.husnummer + ', ' + filteredResult.adresse.postnummer + ' ' + filteredResult.adresse.by | shorten}}</p>
                <p v-if="filteredResult && filteredResult.adresse.etage && !filteredResult.adresse.doer" class="small-text">{{filteredResult.adresse.vejnavn + ' ' +  filteredResult.adresse.husnummer + '. ' + filteredResult.adresse.etage + ', ' + filteredResult.adresse.postnummer + ' ' + filteredResult.adresse.by | shorten}}</p>
                <p v-if="filteredResult && !filteredResult.adresse.etage && filteredResult.adresse.doer" class="small-text">{{filteredResult.adresse.vejnavn + ' ' +  filteredResult.adresse.husnummer + '. ' + filteredResult.adresse.doer + ', ' + filteredResult.adresse.postnummer + ' ' + filteredResult.adresse.by | shorten}}</p>
                <p v-if="filteredResult && filteredResult.adresse.etage && filteredResult.adresse.doer" class="small-text">{{filteredResult.adresse.vejnavn + ' ' +  filteredResult.adresse.husnummer + '. ' + filteredResult.adresse.etage + ' - ' + filteredResult.adresse.doer + ', ' + filteredResult.adresse.postnummer + ' ' + filteredResult.adresse.by | shorten}}</p>
                <p class="time">{{filteredResult.fratid | formattedDate}} - {{filteredResult.tiltid | moment}}</p>
            </div>
        </div>

        <div class="content padding-bottom-big" v-show="show == 'booking'">
            <h5>Måler</h5>
            <div class="special-text under-header">
                <p>{{filteredResult.maalerType}}</p>
                <span>{{filteredResult.maalernummer}}</span>
            </div>

            <div class="grid-x" style="width: 100%;">
                <label for="målerplacering">Målerplacering
                    <input type="text" id="målerplacering" disabled="disabled" v-model="data.målerplacering">
                </label>

                <div class="small-6 cell" style="padding-right: 4px;">
                    <label for="tidligerestand">Tidligere stand
                        <input type="number" v-model="data.tidligerestand" disabled="disabled" id="tidligerestand">
                    </label>
                </div>

                <div class="small-6 cell" style="padding-left: 4px;">
                    <label for="aktuelstand">Aktuel stand
                        <input type="number" v-model="data.tidligereaktuelstand" id="aktuelstand">
                    </label>
                    <p v-if="data.tidligerestand > 0" style="font-size: 0.9rem; margin-top: -5px; padding-left: 2px; font-style: italic; margin-bottom: 0px;">Forventet: {{Math.floor(beregnForventetForbrugForDato(filteredResult.aflaesningsdato, filteredResult.fratid, filteredResult.aarsforbrug)) + data.tidligerestand}}</p>
                </div>
            </div>
            
            <h5 style="margin-top: 10px">Ny måler</h5>
            <!-- <barcode v-if="openScan == true" :scan="openScan" @clicked="onClickChild"></barcode> -->
            <modal v-if="showModal" @close="childClicked"></modal>

            <div class="grid-x">
                <div class="small-6 cell" style="padding-right: 4px;">
                    <label for="number">Nummer
                        <input type="text" v-model="data.nummer" id="number">
                    </label>
                </div>
                <div class="small-2 cell">
                    <button class="button barcode" data-open="barcodeModal" @click="scanClick">
                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px" width="24px" height="24px" viewBox="0 0 28.046 28.046" style="enable-background:new 0 0 28.046 28.046;" xml:space="preserve">
                        <g>
                            <g>
                                <rect y="4.877" width="3.161" height="18.292" fill="#292929"/>
                                <rect x="20.631" y="4.877" width="3.165" height="18.292" fill="#292929"/>
                                <rect x="5.141" y="4.877" width="1.579" height="18.292" fill="#292929"/>
                                <rect x="14.995" y="4.877" width="1.581" height="18.292" fill="#292929"/>
                                <rect x="17.766" y="4.877" width="1.576" height="18.292" fill="#292929"/>
                                <rect x="24.486" y="4.877" width="1.584" height="18.292" fill="#292929"/>
                                <rect x="27.255" y="4.877" width="0.791" height="18.292" fill="#292929"/>
                                <rect x="8.765" y="4.877" width="4.746" height="18.292" fill="#292929"/>
                            </g>
                        </g>
                    </svg>
                    </button>
                </div>

                <div class="small-4 cell" style="padding-left: 6px;">
                    <label for="stand">Aktuel stand
                        <input type="text" v-model="data.aktuelstand" id="stand">
                    </label>
                </div>
            </div>

            <label for="select">Årsag til ny tid
                <select v-model="data.nytidselect" id="select">
                    <option value="0">Ingen valgt</option>
                    <option v-for="timetype in timetypes" :selected="selected" v-bind:key="timetype.id" :value="timetype.id">
                        {{timetype.navn}}
                    </option>
                </select>
            </label>

            <div class="grid-x">
                <div class="small-12 cell">
                    <button class="button call-to-action" @click="saveInfo">Gem</button>
                </div>
            </div>
        </div>

        <div class="content padding-bottom-big" v-show="show == 'customer'">
            <h5>Kundeoplysninger &nbsp; <i class="material-icons person-icon">person</i></h5>
            <div class="customer-info" v-if="filteredResult.kunde">
                <p>{{filteredResult.kunde.navn}}</p>
                <p>{{filteredResult.adresse.vejnavn}} {{filteredResult.adresse.husnummer}}, {{filteredResult.adresse.postnummer}} {{filteredResult.adresse.by}}</p>
                <p>{{filteredResult.by}}</p>
                <p v-if="filteredResult.kunde.email != null || filteredResult.kunde.email != undefined">{{filteredResult.kunde.email}}</p>
                <p v-if="filteredResult.kunde.email == null || filteredResult.kunde.email == undefined">
                    <br />
                    <label for="email">Email
                        <input type="email" id="email" v-model="data.email">
                    </label>
                </p>
                <p v-if="filteredResult.kunde.mobil != null || filteredResult.kunde.mobil != undefined">{{filteredResult.kunde.mobil}}</p>
                <p v-if="filteredResult.kunde.mobil == null || filteredResult.kunde.mobil == undefined">
                    <br v-if="filteredResult.kunde.email != null || filteredResult.kunde.email != undefined" />
                    <label for="phone">Mobil
                        <input type="text" id="phone" v-model="data.mobil">
                    </label>
                </p>
                <a v-if="filteredResult.kunde.email == null || filteredResult.kunde.email == undefined || filteredResult.kunde.mobil == null || filteredResult.kunde.mobil == undefined" class="button call-to-action" @click="saveInfo">Gem</a>
            </div>
            <div class="customer-info no-info" v-if="!filteredResult.kunde">
                <p class="text-center">Der findes ingen oplysninger på kunden</p>
            </div>
        </div>

        <div class="content padding-bottom-big" v-show="show == 'notes'">
            <h5>Noter</h5>
            <textarea rows="4" v-model="note"></textarea>
            <select v-model="noteselect" id="select">
                <option value="-1" disabled="disabled">Ingen valgt</option>
                <option v-for="notetype in notetypes" v-bind:key="notetype.id" :value="notetype.navn">
                    {{notetype.navn}}
                </option>
            </select>
            <button class="button call-to-action" @click="saveInfo">Gem</button>
        </div>

        <div class="content padding-bottom-big" v-show="show == 'images'">
            <div class="addFile">
                <input type="file" name="fileUpload" accept="image/*" v-on:change="gotUpload" capture>
                <i class="material-icons">cloud_upload</i>
                <p>Tilføj billede</p>
            </div>
            <div class="addScreenshot">
                <div v-if="webcam.active">
                    <web-cam ref="webcam" :deviceId="webcam.selectedCameraId" :height="200" @cameras="getAvailableCameras"/>
                    <select v-if="webcam.availableCameras" v-model="webcam.selectedCameraId">
                        <option disabled>Vælg Kamera</option>
                        <option v-for="camera in webcam.availableCameras" :key="camera.deviceId" :value="camera.deviceId">
                            {{ camera.label }}
                        </option>
                    </select>
                    <button class="button call-to-action" @click="capture_screenshot()">Tag screenshot</button>
                </div>
                <button class="button" @click="toggleCamera()">{{webcam.text}}</button>
            </div>
            
            <div class="grid-x">
                <FormUpload v-on:removeUpload="doremoveUpload(upload.id)" v-for="upload in localImages" :upload="upload" :key="upload.id || mongoid"></FormUpload>
            </div>
        </div>

         <footer>
            <div class="grid-x">
                <div class="auto cell" @click="goToBooking" :class="{ 'active-item': show == 'booking' }">
                    <i class="material-icons">date_range</i>
                    <p>Booking</p>
                </div>
                <div class="auto cell" @click="goToCustomer" :class="{ 'active-item': show == 'customer'}">
                    <i class="material-icons">person</i>
                    <p>Kunde</p>
                </div>
                <div class="auto cell"  @click="goToNotes" :class="{ 'active-item': show == 'notes'}">
                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px"
                        width="23px" height="25px" viewBox="0 0 128 128" enable-background="new 0 0 128 128" xml:space="preserve">
                        <g>
                            <g>
                                <path d="M8,112V16c0-4.414,3.594-8,8-8h80c4.414,0,8,3.586,8,8v47.031l8-8V16c0-8.836-7.164-16-16-16H16C7.164,0,0,7.164,0,16v96    c0,8.836,7.164,16,16,16h44v-8H16C11.594,120,8,116.414,8,112z M88,24H24v8h64V24z M88,40H24v8h64V40z M88,56H24v8h64V56z M24,80    h32v-8H24V80z M125.656,72L120,66.344c-1.563-1.563-3.609-2.344-5.656-2.344s-4.094,0.781-5.656,2.344l-34.344,34.344    C72.781,102.25,68,108.293,68,110.34L64,128l17.656-4c0,0,8.094-4.781,9.656-6.344l34.344-34.344    C128.781,80.188,128.781,75.121,125.656,72z M88.492,114.82c-0.453,0.43-2.02,1.488-3.934,2.707l-10.363-10.363    c1.063-1.457,2.246-2.922,2.977-3.648l25.859-25.859l11.313,11.313L88.492,114.82z"
                                    fill="#FFFFFF" />
                            </g>
                        </g>
                    </svg>
                    <p>Noter</p>
                </div>
                <div class="auto cell" @click="goToImages" :class="{ 'active-item': show == 'images' }">
                    <i class="material-icons">camera_alt</i>
                    <p>Billeder</p>
                </div>
            </div>
        </footer>

        <div class="overlay" data-toggle="bottommenu" aria-controls="bottommenu" v-show="overlay" @click="closeMenu"></div>

        <div class="alert-message" v-if="deviation === true">
            <div class="align-alert-item">
                <i class="material-icons">warning</i>
                <h5>Der er en afvigelse på mere end {{maxDeviation}}%</h5>
                <button class="button call-to-action" @click="closeAlert">Luk</button>
            </div>
        </div>

        <div class="popup-message" v-if="popup == true">
            <div class="align-item">
                <i class="material-icons">check_circle</i>
                <h5>Gemt!</h5>
            </div>
        </div>
    </div>
</template>

<script>


import DAL, {mongoObjectId} from './../js/Sync/dal';
import FormUpload from './../components/FormUpload';
import FormUploadHandler from './../mixins/FormUploadHandler';
import modal from './../components/modal';
import { WebCam } from 'vue-web-cam';

require('lightbox2/dist/css/lightbox.css');
require('lightbox2');

export default {
  name: "projekt",
  components: {
    FormUpload,
    modal,
    WebCam
  },
  mixins: [FormUploadHandler],
  data() {
    return {
      showModal: false,
      images: "",
      filteredResult: "",
      show: "booking",
      noteselect: "",
      note: "",
      overlay: false,
      userEmail: "",
      difference: null,
      diff: '',
      localImages: [],
      timetypes: [],
      selected: null,
      notetypes: [],
      data: {
        målerplacering: "",
        tidligerestand: null,
        tidligereaktuelstand: null,
        nummer: null,
        aktuelstand: 0,
        nytidselect: 0,
        email: "",
        mobil: ""
      },
      popup: false,
      maxDeviation: null,
      deviation: false,
      webcam: {
          active: false,
          text: 'Aktiver kamera',
          availableCameras: null,
          selectedCameraId: null
      }
    };
  },
  methods: {
    scanClick() {
        this.showModal = true;
    },
    closeAlert() {
        this.deviation = false
    },
     childClicked(result, value) {
        var _this = this;
        var input = document.getElementById('number');

        if (value == false) {
            if (result != null) {
                _this.data.nummer = result;
                input.value = result;
            }
        }
        console.log("result", result);
        this.showModal = false;
    },
    goBack() {
        this.$router.go(-1);
    },
    gotoMap() {
        this.$router.push({
            name: "kort"
        });
    },
    closeMenu() {
        this.overlay = false;
    },
    receipt() {
        this.overlay = true;
    },
    saveInfo() {
        var data = this.filteredResult;
        var _this = this;

        this.popup = true;

        setTimeout(function(){ 
            _this.popup = false;
        }, 1500);

        data.maalerplacering = this.data.målerplacering;
        data.sidsteaflaesning = this.data.tidligerestand;
        data.maalerStand = this.data.tidligereaktuelstand;
        data.nytMaalernummer = this.data.nummer;
        data.nyMaalerStand = this.data.aktuelstand;
        data.bemaerkning = this.note;
        if (this.noteselect != "") {
            data.bemaerkning += '\r\n' + this.noteselect
        }
        data.nytidTypeId = this.data.nytidselect;
        if (this.data.email != "") {
            data.kunde.email = this.data.email;
        }
        if (this.data.mobil != "") {
            data.kunde.mobil = this.data.mobil
        }

        console.log('data', data)

        DAL.setItem("MTTempData", data.id, data).then(function () {
            _this.$store.dispatch('updateNotification', 1);
        });

        this.checkDeviation() // check om der er en afvigelse på årsforbrug på mere end 15 % 
    },
    removeImage(image) {
        console.log("remove image", image);
    },
    goToBooking() {
        this.show = "booking";
    },
    goToCustomer() {
        this.show = "customer";
    },
    goToNotes() {
        this.show = "notes";
    },
    goToImages() {
        this.show = "images";
    },
    getServerData() {
      var _this = this;

      return new Promise(function(resolve, reject) {
        var tasks = [];

        DAL.iterate("MTTempData", function(value, key, iterationNumber) {
          if (value.id == _this.$route.params.id) {
            tasks.push(value);
          }
        }).then(function () {
            if (tasks.length > 0) {
                console.log("found some data");
            } else {
                return DAL.iterate("MTTasks", function (value, key, iterationNumber) {
                    if (value.id == _this.$route.params.id) {
                        console.log("found something inside tasks", value)
                        tasks.push(value);
                    }
                })
            }
        }).then(function() {
            _this.filteredResult = tasks[0];
            _this.data.målerplacering = _this.filteredResult.maalerplacering;
            _this.data.tidligerestand = _this.filteredResult.sidsteaflaesning;
            _this.data.tidligereaktuelstand = _this.filteredResult.maalerStand;
            _this.data.aktuelstand = _this.filteredResult.nyMaalerStand;
            _this.data.nummer = _this.filteredResult.nytMaalernummer;
            _this.note = _this.filteredResult.bemaerkning;
            _this.data.nytidselect = _this.filteredResult.nytidTypeId;

            if (_this.data.nytidTypeId != undefined) {
                _this.selected = _this.data.nytidTypeId;
            }
            resolve(tasks);
        });
      }).then(function () {
        return new Promise(function(resolve, reject) {
            DAL.iterate('MTTempImages', function(value, key, iterationNumber) {
                if (value.projectId == _this.filteredResult.id) {
                    _this.localImages.push(value);
                }
            }).then(function() {
                console.log("images", _this.localImages);
                resolve(_this.localImages);
            });
          });
      });
    },
    checkDeviation() {
        console.log('check deviation')
        this.beregnForbrugAfvigelseIProcentForDato(this.filteredResult.sidsteaflaesning, this.filteredResult.aflaesningsdato, this.filteredResult.maalerStand, this.filteredResult.fratid, this.filteredResult.aarsforbrug)
    },
    dateString2Date(date) {
        var dateFormat = new Date(date)
        var newDate = new Date(dateFormat.getFullYear(), dateFormat.getMonth(), dateFormat.getDate())
        return newDate;
    },
    beregnForbrug(senesteStand, nyStand) {
        var forbrug = nyStand - senesteStand
        return forbrug
    },
    beregnForventetForbrugForDato(senesteStandDatoTid, nyStandDatoTid, aarsforbrug) {
        var oneDayInMiliseconds = 86400000;
        var totalDays = Math.floor((this.dateString2Date(nyStandDatoTid) - 
                this.dateString2Date(senesteStandDatoTid)) / oneDayInMiliseconds);
        var totalYears = totalDays / 365.0;
        var forventetForbrug = totalYears * aarsforbrug;
        return forventetForbrug;
    },
    beregnForbrugAfvigelseIProcent(forventetForbrug, forbrug) {
        var forbrugAfvigelse = Math.abs(forbrug - forventetForbrug) / forventetForbrug;
        if (forbrugAfvigelse === Infinity || forbrugAfvigelse < 0) {
            forbrugAfvigelse = 0
        }
        var forbrugAfvigelseIProcent = forbrugAfvigelse * 100;
        return forbrugAfvigelseIProcent;
    },
    beregnForbrugAfvigelseIProcentForDato(senesteStand, senesteStandDatoTid, nyStand, nyStandDatoTid, aarsforbrug) {
        var _this = this
        var forventetForbrug = this.beregnForventetForbrugForDato(senesteStandDatoTid, nyStandDatoTid, aarsforbrug);
        console.log('forventetForbrug', forventetForbrug)
        var forbrug = this.beregnForbrug(senesteStand, nyStand);
        console.log('forbrug', forbrug)
        var forbrugAfvigelseIProcent = this.beregnForbrugAfvigelseIProcent(forventetForbrug, forbrug);
        console.log('forbrugAfvigelseIProcent', forbrugAfvigelseIProcent)
        var maxDeviation = null

        DAL.getItem('MTSettings', 'settings').then(function (result) {
            if(result == null) {
                console.log("Kunne ikke finde nogle indstillinger i IDB");
            } else {
                console.log('maxAfvigelseFraForventetForbrug', result.maxAfvigelseFraForventetForbrug)
                _this.maxDeviation = result.maxAfvigelseFraForventetForbrug;
            }
        }).then(() => {
            if (_this.maxDeviation !== null && forbrugAfvigelseIProcent > _this.maxDeviation) {
                _this.deviation = true
                console.log('Der er en afvigelse på mere end ' + _this.maxDeviation + '!')
            }
        })
    },
    capture_screenshot() {
        this.gotScreenshot(this.$refs.webcam.capture())
    },
    toggleCamera() {
        if (this.webcam.active) {
            this.webcam.active = false
            this.webcam.text = 'Aktiver kamera'
            this.webcam.availableCameras = null
            this.webcam.selectedCameraId = null
        } else {
            this.webcam.active = true
            this.webcam.text = 'Deaktiver kamera'
        }
    },
    getAvailableCameras(list) {
        this.webcam.availableCameras = list
        if (list.length > 1) {
           this.webcam.selectedCameraId = list[1].deviceId  
        } else {
            this.webcam.selectedCameraId = list[0].deviceId 
        }
    }
  },
  filters: {
    moment(text) {
        return moment(text).format('HH:mm');
    },
    formattedDate(text) {
        return moment(text).format('DD MMMM [kl.] HH:mm')
    },
    shorten(text) {
      if (text.length > 28) {
        return text.substring(0, 28) + '...';
      }
      return text;
    }
  },
  beforeMount() {
      this.getServerData();
  },
  mounted() {
    var _this = this;
    $(document).foundation();
    $("header").hide();

    _this.openScan = false;

    DAL.getItem('MTTimeTypes', 'timetypes').then(function (result) {
      if(result == null) {
        console.log("Kunne ikke finde nogle tidstyper i IDB");
      } else {
        _this.timetypes = result;
      }
    });

    DAL.getItem('MTNoteTypes', 'notetypes').then(function (result) {
      if(result == null) {
        console.log("Kunne ikke finde nogle bemærkningstyper i IDB");
      } else {
        _this.notetypes = result;
      }
    });

    DAL.getItem('MTBookingTypes', 'bookingtypes').then(function (result) {
      if(result == null) {
        console.log("Kunne ikke finde nogle bookingtyper i IDB");
      } else {
        _this.bookings = result;
      }
    })

    DAL.getItem('MTPlacementTypes', 'placementtypes').then(function (result) {
      if(result == null) {
        console.log("Kunne ikke finde nogle placeringstyper i IDB");
      } else {
        _this.placement = result;
      }
    })
  }
};
</script>


// WEBPACK FOOTER //
// projekt.vue?def74f60